import { DocumentationLegacyPageBlockEmbedGeneric, } from "./SDKDocumentationLegacyPageBlockEmbedGeneric";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DocumentationLegacyPageBlockEmbedLink extends DocumentationLegacyPageBlockEmbedGeneric {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model, children) {
        var _a, _b, _c, _d, _e, _f;
        super(model, children);
        this.title = (_b = (_a = model.urlPreview) === null || _a === void 0 ? void 0 : _a.title) !== null && _b !== void 0 ? _b : null;
        this.description = (_d = (_c = model.urlPreview) === null || _c === void 0 ? void 0 : _c.description) !== null && _d !== void 0 ? _d : null;
        this.thumbnailUrl = (_f = (_e = model.urlPreview) === null || _e === void 0 ? void 0 : _e.thumbnailUrl) !== null && _f !== void 0 ? _f : null;
    }
}
